import { render, staticRenderFns } from "./AvSavings.vue?vue&type=template&id=c02c27e0&lang=pug"
import script from "./AvSavings.vue?vue&type=script&lang=ts"
export * from "./AvSavings.vue?vue&type=script&lang=ts"
import style0 from "./AvSavings.vue?vue&type=style&index=0&id=c02c27e0&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnimatedFlipCounter: require('/app/components/generic/AnimatedFlipCounter.vue').default})
